import { capitalize, includes, join } from 'lodash';

export const capitalizeExceptSpecificWords = ({
  text,
  specificWords = ['on', 'the', 'on the'],
}: {
  text: string;
  specificWords?: string[];
}): string => {
  const words = text.split(' ');
  const modifiedWords = words.map((word) => {
    const lowerCaseWord = word.toLowerCase();
    if (includes(specificWords, lowerCaseWord)) {
      return word;
    }
    return capitalize(word);
  });

  return join(modifiedWords, ' ');
};

export const dayCapitalizedRRuleString = (rRule: string) => {
  if (!rRule) {
    return '';
  }
  const splittedRRule = rRule.split(' ');
  const day = splittedRRule[splittedRRule.length - 1];
  const rest = splittedRRule.slice(0, splittedRRule.length - 1);
  return `${capitalize(rest.join(' '))} ${capitalize(day)}`;
};
